import { Component, OnInit, ViewChild } from '@angular/core'
import { MatTabsModule } from '@angular/material/tabs'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { PatientMainComponent } from '../patient-main/patient-main.component'
import { PatientCreateComponent } from '../../../features/patient/patient-create/patient-create.component'
import { ConsultantClientComponent } from '../consultant-client/consultant-client.component'

@Component({
  selector: 'patient',
  imports: [
    MatTabsModule,
    MatButtonModule,
    PatientMainComponent,
  ],
  templateUrl: './patient.component.html',
  styleUrl: './patient.component.scss',
  standalone: true,
  providers: [AuthService],
})
export class PatientComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  @ViewChild(PatientMainComponent)
  legalEntityClient!: PatientMainComponent
  screenLegalClient: string = 'paciente'
  screenConsultant: string = 'paciente'
  screenSubClient: string = 'paciente'

  ngOnInit() {}

  checkPermission(permission: string, type: 'legal' | 'sub' | 'consultant') {
    let response = false
    if (type == 'legal') {
      response = this.authService.checkPermission(
        permission,
        this.screenLegalClient,
      )
    } else if (type == 'sub') {
      response = this.authService.checkPermission(
        permission,
        // this.screenSubClient,
        'consultores-clientes',
      )
    } else if (type == 'consultant') {
      response = this.authService.checkPermission(
        permission,
        this.screenConsultant,
      )
    }
    return response
  }

  newClient() {
    const dialogRef = this.dialog.open(PatientCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.legalEntityClient?.uploadList()
    })
  }

}
